import { LOGIN_PAGE_BASE_PATH } from 'src/constants/loginPath';
import { STUDIO_REFERRER } from 'src/routes/onboarding/setup/constants';
import { withLoopAttribution } from 'src/utils/loopAttribution';
import UrlUtils from 'src/utils/UrlUtils';

export type BuildStudioLoginPathInput = {
  prompt?: string;
  workspaceTemplateId?: string;
  workspaceTemplateName?: string;
  /**
   * Source app id for the marketing → App Builder template handoff.
   * Distinct from `workspaceTemplateId` / `template_id` (classic workspace templates).
   * Display-only `templateName` / `templateDescription` are not preserved here —
   * they only render on the landing Get started URL.
   */
  templateId?: string;
  next?: string;
  /** Prefill the Studio login email field (e.g. after select-email re-auth). */
  email?: string;
};

/**
 * Canonical builder for the Studio login page (`/login?referrer=studio`).
 * `OnboardingLoginPage` renders the passwordless Studio login screen only when
 * the `referrer=studio` param is present, so routing helpers must go through
 * this rather than hand-building the URL. Mirrors `buildStudioSignupPath` so the
 * signup <-> login cross-navigation threads the same context params instead of
 * dropping the user into classic login.
 */
export const buildStudioLoginPath = ({
  prompt,
  workspaceTemplateId,
  workspaceTemplateName,
  templateId,
  next,
  email,
}: BuildStudioLoginPathInput = {}): string => {
  const params: Record<string, string> = {
    referrer: STUDIO_REFERRER,
  };

  if (prompt) {
    params.prompt = prompt;
  }
  if (workspaceTemplateId) {
    params.template_id = workspaceTemplateId;
    if (workspaceTemplateName) {
      params.template_name = workspaceTemplateName;
    }
  }
  if (templateId) {
    params.templateId = templateId;
  }
  if (next) {
    params.next = next;
  }
  if (email) {
    params.email = email;
  }

  return `${LOGIN_PAGE_BASE_PATH}?${UrlUtils.FormatUrlQueryToString(
    withLoopAttribution(params),
  )}`;
};
